"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const rightsholder_status_helpers_1 = require("@App/helpers/rightsholder-status-helpers");
const get_date_iso_6801_1 = require("@App/helpers/get-date-iso-6801");
const clsx_1 = __importDefault(require("clsx"));
const AccountCard = (props) => {
    const { name, totalWorks, isValidationStatusWrong, teamMembers, validationStatus, updateDate, openPopup, viewDetails = true, link, icon, blueImageFilter, } = props;
    const date = updateDate ? (0, get_date_iso_6801_1.getDateFromIso)(updateDate) : '';
    return (react_1.default.createElement("div", { className: "account-card" },
        react_1.default.createElement("div", { className: "head-block" },
            react_1.default.createElement("img", { className: (0, clsx_1.default)(blueImageFilter && 'filtered'), src: icon, alt: "account" }),
            viewDetails &&
                (isValidationStatusWrong ? (react_1.default.createElement("p", { onClick: openPopup }, "View")) : (react_1.default.createElement(react_router_dom_1.Link, { to: link, className: 'link bold' }, "View")))),
        react_1.default.createElement("div", { className: 'info-block' },
            react_1.default.createElement("h5", null, name),
            teamMembers !== undefined && (react_1.default.createElement("p", { className: 'count' },
                react_1.default.createElement("span", { className: "bold" }, teamMembers),
                " connected user accounts")),
            react_1.default.createElement("p", { className: 'count' },
                react_1.default.createElement("span", { className: "bold" }, totalWorks.toLocaleString()),
                " total works")),
        updateDate && validationStatus && (react_1.default.createElement("div", { className: "bottom-block" },
            react_1.default.createElement("p", { className: 'small' },
                "Status: ",
                (0, rightsholder_status_helpers_1.getStrRHStatus)(validationStatus)),
            react_1.default.createElement("p", { className: 'small bold' }, date)))));
};
exports.default = AccountCard;
